import React from 'react';
import { AlertTriangle, CheckCircle, TrendingUp, Users } from 'lucide-react';
import { StatsCard } from './StatsCard';
import { DashboardData } from '../../types';

interface StatsCardGridProps {
	data: DashboardData;
}

export const StatsCardGrid: React.FC<StatsCardGridProps> = ({ data }) => {
	return (
		<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
			<StatsCard
				title="Total Clients"
				value={data.platform.totalClients}
				subtitle="+2 this month"
				icon={Users}
				status="success"
			/>
			<StatsCard
				title="Active Integrations"
				value={`${((data.platform.activeClients / Math.max(data.platform.totalClients, 1)) * 100).toFixed(2)}%`}
				subtitle="80% configured"
				icon={CheckCircle}
				status="success"
			/>
			<StatsCard
				title="Success Rate"
				value={`${data.syncHealth.successRate.toFixed(2)}%`}
				trend="+0.2% vs last week"
				trendPositive={true}
				icon={TrendingUp}
				status="success"
			/>
			<StatsCard
				title="Need Attention"
				value={data.syncHealth.failedSyncs + data.queue.failed}
				subtitle="Requires action"
				icon={AlertTriangle}
				status={data.syncHealth.failedSyncs + data.queue.failed > 0 ? 'warning' : 'success'}
			/>
		</div>
	);
};
